export default __webpack_public_path__ + "ae98be4be1aff56b0518e75719e79f9a.svg";